"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerpackungCalculator = void 0;
const echain_math_1 = require("@igus/echain-math");
const echain_shared_articles_oo_1 = require("@igus/echain-shared-articles-oo");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_shared_configurations_1 = require("@igus/echain-shared-configurations");
/**
 * The `VerpackungCalculator` has the responsibility to
 * bundle functions to calculate the Verpackungsdurchmesser
 */
class VerpackungCalculator {
    /**
     * Calculates the Kette Durchmesser for any type of Verpackung
     */
    static calculateKetteDurchmesser(verpackung, configuration) {
        const configModel = configuration.toModel();
        let kette;
        let outerHeight;
        let chainLength;
        const { type, config } = (0, echain_shared_configurations_1.asTypedConfigurationUnion)(configModel);
        switch (type) {
            case 'Empty':
            case 'Espool':
            case 'EspoolChild':
                return undefined;
            case 'Kette':
                kette = (0, echain_shared_articles_oo_1.A)(config.Kette);
                outerHeight = kette.aussenhoehe;
                chainLength = kette.getMostPreciseEffektiveLaenge();
                break;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(type);
        }
        if (!outerHeight) {
            throw new Error(`${this.className}.calculateKetteDurchmesser: aussenhoehe is undefined`);
        }
        const kerndurchmesserKette = this.getKetteKerndurchmesser(verpackung, kette);
        if (kerndurchmesserKette && chainLength) {
            const windungKette = echain_math_1.VerpackungMath.calcKetteWindungen(kerndurchmesserKette.mm, outerHeight.mm, chainLength.mm);
            if (windungKette) {
                return echain_shared_quantities_1.Q.optional(echain_math_1.VerpackungMath.calcAussendurchmesserKetteForPalette_mm(kerndurchmesserKette.mm, windungKette, outerHeight.mm), 'mm');
            }
        }
        return undefined;
    }
    /**
     * Calculates the Kette Kerndurchmesser for Verpackung type `Trommel` or `Palette`
     */
    static getKetteKerndurchmesser(verpackung, kette) {
        const ketteModel = kette.toModel();
        const biegeradius = ketteModel.Biegeradius;
        if (!biegeradius) {
            throw new Error(`${this.className}.getKetteKerndurchmesser: kette.Biegeradius is undefined`);
        }
        if (verpackung instanceof echain_shared_articles_oo_1.Trommel) {
            if (verpackung.kerndurchmesser == null)
                return; // invented Verpackung of type `Trommel`
            if (!ketteModel.KetteSerieType) {
                throw new Error(`${this.className}.getKetteKerndurchmesser: kette.KetteSerieType is undefined`);
            }
            const ketteSerieType = ketteModel.KetteSerieType;
            switch (ketteSerieType) {
                case echain_shared_articles_1.KetteSerieType.default:
                case echain_shared_articles_1.KetteSerieType.eskin:
                case echain_shared_articles_1.KetteSerieType.triflexR:
                case echain_shared_articles_1.KetteSerieType.trxe:
                case echain_shared_articles_1.KetteSerieType.rxRohr:
                case echain_shared_articles_1.KetteSerieType.twisterchain:
                case echain_shared_articles_1.KetteSerieType.rolEchain:
                    return echain_shared_quantities_1.Q.optional(echain_math_1.VerpackungMath.calcKetteKerndurchmesser_mm(verpackung.kerndurchmesser.mm, (0, echain_shared_quantities_1.Q)(biegeradius).mm), 'mm');
                case echain_shared_articles_1.KetteSerieType.twisterband:
                    return echain_shared_quantities_1.Q.optional(echain_math_1.VerpackungMath.calcKetteKerndurchmesser_mm(verpackung.kerndurchmesser.mm, 1), 'mm');
                default:
                    (0, echain_shared_ts_utils_1.assertUnreachable)(ketteSerieType);
            }
        }
        else if (verpackung instanceof echain_shared_articles_oo_1.Palette) {
            return echain_shared_quantities_1.Q.optional(echain_math_1.VerpackungMath.calcKetteKerndurchmesser_mm(0, (0, echain_shared_quantities_1.Q)(biegeradius).mm), 'mm');
        }
        return undefined;
    }
}
exports.VerpackungCalculator = VerpackungCalculator;
VerpackungCalculator.className = 'VerpackungCalculator';
//# sourceMappingURL=VerpackungCalculator.js.map